import * as z from "zod";

const humanQueueSendDetailsSchema = z.discriminatedUnion(
  "sentContentWasModified",
  [
    z.object({ email: z.string(), sentContentWasModified: z.literal(false) }),
    z.object({
      email: z.string(),
      sentContentWasModified: z.literal(true),
      originalContent: z.string(),
    }),
  ],
);

export const humanQueueSendersSchema = z.record(
  z.string(),
  humanQueueSendDetailsSchema,
);

export type HumanQueueSendDetails = z.infer<typeof humanQueueSendDetailsSchema>;
export type HumanQueueSenders = z.infer<typeof humanQueueSendersSchema>;
